import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles } from "@material-ui/core/styles";
import Popper from '@material-ui/core/Popper';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Badge from '@material-ui/core/Badge';
import Add from '@material-ui/icons/Add';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import NotificationService from '../../../../../services/NotificationService/NotificationService';
import QueueService from '../../../../../services/QueueService/QueueService';
import { useRecoilValue } from 'recoil';
import { unreadNotificationCount } from "../../../../../recoil-store/recoil-state"

const useStyles = makeStyles({
    badge: { backgroundColor: '#f64e60' }
});

/**
 * @Description This function lets you return Dashboard component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Notifications() {
    const count = useRecoilValue(unreadNotificationCount);
    // Initial states
    const label = 'CONTENT.DASHBOARD.';
    const { t } = useTranslation();
    const classes = useStyles();
    const [state, setState] = useState({ notifications: [], pending: 0 });
    const [anchorEl, setAnchorEl] = useState(null);
    // Fetch Notifications data
    const fetchData = async () => {
        let notifications = [], pending = 0;
        let res = await NotificationService.getNotifications(true);
        if (res?.status && res.data) { notifications = res.data; };
        res = await QueueService.getQueueStatus(['PENDING']);
        if (res?.status && res.data) { pending = res.data.count; }
        setState({ notifications, pending })
    }
    // Handle mark as read click
    const handleRead = async () => {
        if (state.notifications.length > 0) {
            let notificationIds = [];
            for (const item of state.notifications) { notificationIds.push(item.id); }
            let res = await NotificationService.changeReadStatus({ read_status: true, notificationIds });
            if (res?.status) { setAnchorEl(null); fetchData(); }
        }
    }
    // Handle popup toggle
    function handleClick(event) {
        if (anchorEl) { setAnchorEl(null); }
        else { fetchData(); setAnchorEl(event.currentTarget); }
    }
    // Handle popup close
    function handleClose(event) {
        if (anchorEl && anchorEl.contains(event.target)) {
            return;
        }
        setAnchorEl(null);
    }
    const open = Boolean(anchorEl);
    return (
        <div className="db-row db-notifications">
            <div>
                {count > 0 && (<Button className="db-page" onClick={handleClick}>
                    {t('CONTENT.CREDENTIAL-TAB.LOCALE') === 'tr-TR' ?
                        <span><b>{count} Bildiriminiz</b> var.</span> :
                        <span>You have &nbsp;<b>{count} Notification{count > 1 ? 's' : ''}</b>.</span>
                    }
                    <Badge
                        badgeContent={count ? '' : 0}
                        classes={{ badge: classes.badge }}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                        <div style={{ height: 25, width: 10 }}></div>
                    </Badge>
                </Button>)}
                <Popper open={open} anchorEl={anchorEl} style={{ marginTop: 10, minWidth: 205 }} transition>
                    {({ TransitionProps }) => (
                        <ClickAwayListener onClickAway={handleClose}>
                            <Fade {...TransitionProps} timeout={350}>
                                <Paper style={{ padding: 15 }}>
                                    <div className="db-label" style={{ borderBottom: '2px solid #f6f6f6', paddingBottom: 10, marginBottom: 10 }}>Notifications</div>
                                    {state.notifications.map((item, itemI) => {
                                        return (
                                            <div key={itemI} className="db-seclabel" style={{ margin: '10px 0' }}>{item.title}</div>
                                        );
                                    })}
                                    <div style={{ textAlign: 'center', marginTop: 15 }}>
                                        <Button style={{ backgroundColor: '#002742', color: '#fff' }} onClick={handleRead}>Mark as Read</Button>
                                    </div>
                                </Paper>
                            </Fade>
                        </ClickAwayListener>
                    )}
                </Popper>
                <div className="db-page pending-action">
                    {t('CONTENT.CREDENTIAL-TAB.LOCALE') === 'tr-TR' ?
                        <span><span style={{ fontWeight: 'bold' }}>{state.pending} Aksiyon Beklemede</span>.</span> :
                        <span>You have &nbsp;<span style={{ fontWeight: 'bold' }}>{state.pending} Action{state.pending > 1 ? 's' : ''} Pending</span>.</span>
                    }
                </div>
            </div>
            <Link to="/autom-new"><Button><Add fontSize="small" /> &nbsp;{t(label + 'CREATE-AUTOM')}</Button></Link>
        </div>
    );
}

export default Notifications;
